import { GAME_CONFIG } from '../config/gameConfig';
import type { GameState, Vec2 } from './types';

export const baseStationPos: Vec2 = { x: -11, z: 0 };
export const truckParkingPos: Vec2 = { x: -11, z: -3.2 };
export const dronePadPos: Vec2 = { x: -11, z: 3.2 };

export function createInitialState(): GameState {
  return {
    cash: GAME_CONFIG.economy.startingCash,
    phase: 'playing',
    autoPilotActive: true,
    selectedTool: 'auto',
    hoveredFieldId: null,
    selectedFieldId: null,
    fields: [
      {
        id: 1,
        name: 'Parcella A',
        x: -5,
        z: -5,
        size: 5,
        infection: 10,
        ndviRemaining: 0,
        mesh: null,
        ndviMesh: null,
      },
      {
        id: 2,
        name: 'Parcella B',
        x: 5,
        z: -5,
        size: 5,
        infection: 40,
        ndviRemaining: 0,
        mesh: null,
        ndviMesh: null,
      },
      {
        id: 3,
        name: 'Parcella C',
        x: -5,
        z: 5,
        size: 5,
        infection: 15,
        ndviRemaining: 0,
        mesh: null,
        ndviMesh: null,
      },
      {
        id: 4,
        name: 'Parcella D',
        x: 5,
        z: 5,
        size: 5,
        infection: 75,
        ndviRemaining: 0,
        mesh: null,
        ndviMesh: null,
      },
    ],
    truck: {
      x: truckParkingPos.x,
      z: truckParkingPos.z,
      targetFieldId: null,
      state: 'Idle',
      task: null,
      progress: 0,
      speed: GAME_CONFIG.units.truck.speed,
      mesh: null,
    },
    drone: {
      x: dronePadPos.x,
      z: dronePadPos.z,
      y: GAME_CONFIG.units.drone.landAltitude,
      targetFieldId: null,
      state: 'Idle',
      task: null,
      progress: 0,
      speed: GAME_CONFIG.units.drone.speed,
      mesh: null,
      rotors: [],
      cameraLens: null,
    },
  };
}
